<mcg-loader [message]="translate('Cargando_datos')" [showLoader]="isLoading"></mcg-loader>

<div class="row" style="height: calc(100% - 30px); width: 100%; overflow-x: hidden;">
  <div style="width: 45%;">
    <h3>{{translate('Moviles_asociados')}}</h3>
    <jqxGrid #gridMovilesAsignados [theme]="tema" [width]="'100%'" [height]="'calc(100% - 40px)'"
      [appCellClick] [source]="adapterMovilesAsignados" [columnsresize]="true" [localization]="langGrid"
      [filterable]="true" [showfilterrow]="false" [columns]="columnsMoviles" [showrowlines]="false"
      [showcolumnlines]="true" [pageable]="false" [sortable]="true" [altrows]="true" [showstatusbar]="false"
      [statusbarheight]="0" [enablebrowserselection]="true" [showaggregates]="false" [rowsheight]="20"
      [columnsheight]="20" [enabletooltips]="false" [editable]="false" [groupable]="false" [selectionmode]="'singlerow'"
      (onRowclick)="onRowSelectAsignada($event)">
    </jqxGrid>
  </div>
  <div style="width: 10%;">
    <div class="rowC" style="height: 80%;">
      <jqxButton class="button" style="margin-bottom: 25%; cursor: pointer;" [width]="25" [height]="25" [imgHeight]="15"
        [imgWidth]="15" [imgSrc]='"/assets/images/izquierda.png"' [imgPosition]="'center'"
        (onClick)="associateMovil()" [disabled]="!(movilLibreSelect)">
      </jqxButton>
      <jqxButton class="button" style="margin-top: 25%; cursor: pointer;" [width]="25" [height]="25" [imgHeight]="15"
        [imgWidth]="15" [imgSrc]='"/assets/images/derecha.png"' [imgPosition]="'center'"
        (onClick)="disassociateMovil()" [disabled]="!(movilAsignadoSelect)">
      </jqxButton>
    </div>
  </div>
  <div style="width: 45%;">
    <h3>{{translate('Moviles_libres')}}</h3>
    <jqxGrid #gridMovilesLibres [theme]="tema" [width]="'100%'" [height]="'calc(100% - 40px)'"
      [appCellClick] [source]="adapterMovilesLibres" [columnsresize]="true" [localization]="langGrid"
      [filterable]="true" [showfilterrow]="false" [columns]="columnsMoviles" [showrowlines]="false"
      [showcolumnlines]="true" [pageable]="false" [sortable]="true" [altrows]="true" [rowsheight]="20"
      [columnsheight]="20" [enablebrowserselection]="true" [enabletooltips]="false" [editable]="false"
      [groupable]="false" [selectionmode]="'singlerow'" [showstatusbar]="false"
      (onRowclick)="onRowSelectLibre($event)">
    </jqxGrid>
  </div>
</div>


<div style="position: absolute; bottom: 5px; left: 5px; margin-top: 5px; clear: both; display: flex; gap: 4px">
  <jqxButton style="float:left" [width]='100' [height]='26' [textImageRelation]='"imageBeforeText"'
    [textPosition]='"left"' [imgPosition]="'left'" [imgSrc]='"/assets/images/save.png"'
    [value]="translate('Guardar')" (onClick)="onGuardarMoviles()">
  </jqxButton>
</div>
